import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import VehicleView from '@/views/vehicleView.vue'
import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import AboutView from '@/views/AboutView.vue'
import CustomerView from '@/views/CustomerView.vue'

import ServicesView from '@/views/ServicesView.vue'
import ContactView from '@/views/ContactView.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'About us',
    component: AboutView
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/vehicle-list',
    name: 'Vehicle List',
    component: VehicleView
  },
{
  path: '/customers',
  name: 'Customers',
  component: CustomerView

},
  {
    path: '/services',
    name: 'Services',
    component: ServicesView,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView,
  },

]

const router = new VueRouter({
  routes
})

export default router
